import img1 from '../img/portImages/EVM.jpg';
import img2 from '../img/portImages/tictactoe.png';
import img3 from '../img/portImages/musicstream.png';
import img4 from '../img/portImages/sds.png';
import img5 from '../img/portImages/tambola.png';
import img6 from '../img/portImages/bugfiling.png';
import img7 from '../img/portImages/zipfile.png';

const portfolios = [
    {
        id: 1,
        category: 'C',
        image: img1,
        link1: 'https://github.com/tejasrajanna/ELECTRONIC-VOTING-MACHINE',
        title: 'Electronic Voting Machine',
        text: 'Depicts voting process, helps understand internal working'
    },
    {
        id: 2,
        category: 'Python',
        image: img2,
        link1: 'https://github.com/tejasrajanna/Discord_TicTacToe_Bot',
        title: 'Discord Tic-Tac-Toe Bot',
        text: 'Enables users to play tictactoe in a discord channel'
    },
    {
        id: 3,
        category: 'Web Dev',
        image: img3,
        link1: 'https://github.com/tejasrajanna/Music-Streaming',
        title: 'Music Streaming Website',
        text: 'MERN stack web application with integrated login page'
    },
    {
        id: 4,
        category: 'Python',
        image: img4,
        link1: 'https://github.com/tejasrajanna/Used-Cars',
        title: 'Hypothesis Testing',
        text: 'EDA on used cars dataset'
    },
    {
        id: 5,
        category: 'Python',
        image: img5,
        link1: 'https://github.com/tejasrajanna/Bingo',
        title: 'Bingo',
        text: 'Card/Ticket Generator'
    },
    {
        id: 6,
        category: 'C',
        image: img6,
        link1: 'https://github.com/tejasrajanna/Bug-Filing',
        title: 'Bug Filing',
        text: 'Report bugs and oversee response'
    },
    {
        id: 7,
        category: 'Python',
        image: img7,
        link1: 'https://github.com/tejasrajanna/Zipfile',
        title: 'Zipfile',
        text: 'Extract text and list common words'
    }
]

export default portfolios;